'use client';

import type { Ref } from 'react';

import classnames from 'classnames';

import type { FlipCardProps } from './FlipCard.types';

import styles from './FlipCard.module.scss';

export function FlipCard({
  style,
  className,
  direction = 'horizontal',
  disabled = false,
  flipped = false,
  frontChildren,
  backChildren,
  testId = 'ui-flip-card',
  ref,
  ...rest
}: FlipCardProps & { ref?: Ref<HTMLDivElement> }) {
  return (
    <div
      ref={ref}
      style={style}
      className={classnames(
        styles['flip-card'],
        disabled && styles['flip-card--disabled'],
        className,
      )}
      data-testid={testId}
      {...rest}
    >
      <div
        className={classnames(
          styles['flip-card-inner'],
          flipped && styles[`flip-card-inner--flipped-${direction}`],
        )}
      >
        <div className={styles['flip-card-front']} aria-hidden={flipped}>
          {frontChildren}
        </div>
        <div
          className={classnames(
            styles['flip-card-back'],
            styles[`flip-card-back--${direction}`],
          )}
          aria-hidden={!flipped}
        >
          {backChildren}
        </div>
      </div>
    </div>
  );
}
